import { SignOutIcon } from "@primer/octicons-react";
import { ActionList, ActionMenu, IconButton, Text } from '@primer/react';
// import {Text} from '@primer/react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from "../../state/reducers";
import { actions } from "../../state/actions/actionsWrapper";
import UserAvatar from "../user-avatar";
import { useLanguage } from "../../hooks/useLanguage";

const UserPanel = () => {
    const { user_info } = useSelector((x: RootState) => x.auth)
    const { language } = useLanguage();
    const dispatch = useDispatch();
    const userIcon = () => {
        return (
            <UserAvatar
                fullName={user_info?.full_name}
                url={`${user_info?.img}`}
            />
            // <img src={`${user_info?.img}`}
            //     width={"28px"}
            //     height={"28px"}
            //     style={{
            //         borderRadius: "50%"
            //     }}
            // />
        )
    }
    const handleLogout = () => {
        dispatch(actions.account.logOutStart())
    }
    return (
        <ActionMenu>
            <ActionMenu.Anchor>
                <IconButton icon={userIcon} aria-label="Laguage" variant='invisible'
                    size="large"
                />
            </ActionMenu.Anchor>

            <ActionMenu.Overlay>
                <ActionList>

                    <ActionList.Item>
                        <Text sx={{
                            fontWeight: "bold"
                        }}>{user_info?.full_name}</Text>
                        <br />
                        <Text>{user_info?.username}</Text>
                    </ActionList.Item>
                    <ActionList.Divider />
                    <ActionList.Item variant="danger" onClick={handleLogout}>
                        <ActionList.LeadingVisual>
                            <SignOutIcon />
                        </ActionList.LeadingVisual>
                        {language === "en" ? "Log out" : "Đăng xuất"}
                    </ActionList.Item>
                </ActionList>
            </ActionMenu.Overlay>
        </ActionMenu>

    );
};

export default UserPanel;